<div
  class="tk-blob -top-1/4 right-1/4 w-[120vw] md:-right-1/3 md:top-1/2 md:w-[90vw]"
  style="--amount: 3; --time: 45s"
>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 274 303.2">
    <path
      d="M260.2 41.4c20 29.2 14.6 74.5 7.2 124.4-7.3 49.9-16.6 104.5-49.2 126-32.5 21.6-88.4 10.2-132-15.2s-75-64.7-83.6-107.8C-6.1 125.7 8 79 36.3 47.8 64.5 16.7 107 1.3 150.9.1c43.9-1.1 89.3 12 109.3 41.3z"
    ></path>
  </svg>
</div>
<div
  class="tk-blob -bottom-1/4 -right-1/2 w-[120vw] md:bottom-1/3 md:right-1/2 md:w-[90vw]"
  style="--amount: 5; --time: 60s"
>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 317.5 353.7">
    <path
      d="M291.8 55.3c30.4 39.9 30.7 102 17 160.4-13.8 58.3-41.6 112.9-84 130.9s-99.3-.6-137-30C50.2 287.1 32 246.9 17 200.5 2.1 154.1-9.6 101.4 11.5 63.6 32.6 25.8 86.6 2.8 143.8.2c57.2-2.6 117.6 15.2 148 55.1z"
    ></path>
  </svg>
</div>
